import { HttpClient } from '@angular/common/http';
import {NgModule} from '@angular/core';
import {QRCodeModule} from 'angularx-qrcode';
import {CookieService} from 'ngx-cookie-service';
import {SharedModule} from '../../app-common/shared.module';
import {BankidComponent} from '../../components/bankid/bankid.component';
import {BankidService} from '../../services/bankid.service';
import {MockBankidService} from '../../services/mocks/mock-bankid.service';
import {authRoutingComponents, AuthRoutingModule} from './auth-routing.module';
import {AppConfigService} from '../../services/app-config.service';
import {UiButtonComponent} from '../../components/ui/ui-button/ui-button.component';

@NgModule({
  declarations: [authRoutingComponents, BankidComponent],
  imports: [SharedModule, AuthRoutingModule, QRCodeModule, UiButtonComponent],
  providers: [
    CookieService,
    {
      provide: BankidService,
      useFactory: (a: AppConfigService, h: HttpClient, c: CookieService) =>
        a.appConfig.features.fakeBankId ? new MockBankidService(a, h, c) : new BankidService(a, h, c),
      deps: [AppConfigService, HttpClient, CookieService],
    },
  ],
})
export class AuthModule {}
